module.exports = __webpack_public_path__ + "noSpongexResize_opt.jpg?86536b71235221b54aad25001fdabfe6";


//////////////////
// WEBPACK FOOTER
// ./src/img/noSpongexResize_opt.jpg
// module id = 388
// module chunks = 0